module.exports = __webpack_public_path__ + "2c165436bca770711271376fd10b2788.pdf";